module.exports = __webpack_public_path__ + "assets/img/23@3x.91e840eb.png";